import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { formatNumber, formatSubcontractorName } from "../../common/Misc";

const ExpandJournalEntry = ({ projectId, id, expandJournalData }) => {
  const ExGSTClaculate = (value, tax) => {
    return tax === 0
      ? formatNumber(Number(value))
      : formatNumber(Number(Number(value) - (Number(value) / 1.1) * 0.1));
  };

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  const journalDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandJournalData[i]?.id,
        transactionDate: expandJournalData[i]?.transactionDate
          ? expandJournalData[i]?.transactionDate
          : "",
        account: expandJournalData[i]?.chart_of_account
          ? (expandJournalData[i]?.chart_of_account?.code?.length < 4
              ? padWithLeadingZeros(
                  Number(expandJournalData[i]?.chart_of_account?.code),
                  4
                )
              : expandJournalData[i]?.chart_of_account?.code.toString()) +
            (expandJournalData[i]?.chart_of_account?.sub_code
              ? "." +
                expandJournalData[i]?.chart_of_account?.sub_code.toString()
              : "") +
            " - " +
            expandJournalData[i]?.chart_of_account?.name
          : "",
        contact: expandJournalData[i]?.contact
          ? formatSubcontractorName(expandJournalData[i]?.contact) +
            `${
              expandJournalData[i]?.contact?.is_pta === 0
                ? " - RTA"
                : expandJournalData[i]?.contact?.is_pta === 1
                ? " - PTA"
                : expandJournalData[i]?.contact?.is_pta === 2
                ? " - Withdrawal/General Business"
                : expandJournalData[i]?.contact?.is_pta === 3
                ? " - Principal"
                : expandJournalData[i]?.contact?.is_pta === 4
                ? " - Trustee"
                : ""
            }` +
            (expandJournalData[i]?.contract?.contract_number
              ? ` (${expandJournalData[i]?.contract?.contract_number})`
              : "")
          : "-",
        debit:
          expandJournalData[i]?.transaction_type === 0
            ? expandJournalData[i]?.amount
              ? "$" + formatNumber(Number(expandJournalData[i]?.amount))
              : "$0.00"
            : "-",
        credit:
          expandJournalData[i]?.transaction_type === 1
            ? expandJournalData[i]?.amount
              ? "$" + formatNumber(Number(expandJournalData[i]?.amount))
              : "$0.00"
            : "-",
        gst:
          expandJournalData[i]?.gst === 0
            ? "GST Excluded"
            : expandJournalData[i]?.gst === 1
            ? "GST 10%"
            : expandJournalData[i]?.gst === 2
            ? "BAS Excluded"
            : "GST on Imports",
        tax: expandJournalData[i]?.gst_amount
          ? "$" + formatNumber(Number(expandJournalData[i]?.gst_amount))
          : "-",
        ex_gst_amount: expandJournalData[i]?.amount
          ? "$" +
            ExGSTClaculate(
              expandJournalData[i]?.amount,
              expandJournalData[i]?.gst
            )
          : 0,
        description: expandJournalData[i]?.description
          ? expandJournalData[i]?.description
          : "-",
      });
    }
    return items;
  };
  const journalData = journalDataGenerator(expandJournalData?.length);

  const columns = [
    {
      dataField: "contact",
      text: "Contact ",
      style: { width: "18%" },
    },
    {
      dataField: "debit",
      text: "Debit",
      style: { width: "15%" },
    },
    {
      dataField: "credit",
      text: "Credit",
      style: { width: "15%" },
    },
    {
      dataField: "description",
      text: "Description",
    },
  ];

  return (
    <>
      <div className="content-details">
        <div className="custom-table journal-expand-table">
          <BootstrapTable
            keyField="key"
            data={journalData}
            columns={columns}
            noDataIndication="No Data Found"
          />
        </div>
      </div>
    </>
  );
};

export default ExpandJournalEntry;
